/* eslint-disable array-callback-return */
import arrayGroupBy from './arrayGroupBy';

export default function arrayFixerObjects(array, date, paramFilter) {
  const filter = paramFilter || date;
  const orderParams = array.reduce((newArray, a) => {
    const found = newArray.find((param) => param === a[filter]);
    if (found === undefined) newArray.push(a[filter]);
    return newArray;
  }, []);

  const orderKeyParams = array.reduce((newArray, a) => {
    Object.keys(a).reduce((arrayKey, current) => {
      const found = newArray.find((param) => param === current);
      if (found === undefined) {
        newArray.push(current);
      }
    });
    return newArray;
  }, []);

  const tableArray = arrayGroupBy(array, date);
  const newDate = tableArray;
  tableArray.forEach((value, index) => {
    orderParams.forEach((item) => {
      const search = value.findIndex((empresa) => empresa[filter] === item);
      if (search === -1) {
        newDate[index].push({ [date]: value[0][date], [filter]: item });
      }
    });
  });

  // normalizo el array  con la información  correcta
  const totalArray = newDate.reduce((newArray, a) => {
    a.forEach((element) => {
      newArray.push(element);
    });
    return newArray;
  }, []);

  totalArray.forEach((item, index) => {
    orderKeyParams.forEach((searchKey) => {
      const searh = Object.keys(item).some((elem) => elem.includes(searchKey));
      if (!searh) {
        Object.assign(totalArray[index], { [searchKey]: 0 });
      }
    });
  });

  return totalArray || [];
}
